import React from "react";
import Card from "../../components/card/Card";
import NsScrollableTabs from "../../components/NsScrollableTabs";
import FormModificaMacrocategoriaController from "./components/FormModificaMacrocategoriaController";

export default function ModificaMacrocategoriaView({
                                                       id,
                                                       idClasse,
                                                       formikRefPrinc,
                                                       elemento,
                                                       translate,
                                                       history,
                                                       keyTab,
                                                       setKeyTab,
                                                       scrollableTabs,
                                                       bottoniSx,
                                                       bottoniDx,
                                                   }) {

    return (
        <Card
            icon={'fas fa-tag'}
            title={elemento && elemento.descrizione ? translate("Modifica Struttura KPI: ") + elemento.descrizione : 'Inserisci Struttura KPI'}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        >
            {
                id ?
                    <FormModificaMacrocategoriaController
                        id={id}
                        idClasse={idClasse}
                        history={history}
                        formikRef={formikRefPrinc}
                        principale={elemento && (!elemento.id_kpi_macrocategoria_madre || elemento.id_kpi_macrocategoria_madre === '')}
                        elemento={elemento}
                    />
                    :
                    <NsScrollableTabs
                        activeIndex={keyTab}
                        onTabChange={(e) => setKeyTab(e.index)}
                        scrollableTabs={scrollableTabs}
                    />
            }
        </Card>
    );
}